import styled from "styled-components";
import { ReactComponent as Light } from "../assets/icon-component/light.svg";
import { ReactComponent as LightABC } from "../../../abc/src/data/icon-component/theme_switcher.svg";
import { isMobileOnly, isTablet } from "react-device-detect";
import { is } from "date-fns/locale";

export const StyledLight = styled(Light)`
  cursor: pointer;
  width: 40px;
  fill: var(--icon-bulb);
  margin: 0 12px;
  @media (max-width: 767px) {
    margin: 0;
  }
`;

export const StyledLightABC = styled(LightABC)`
  cursor: pointer;
  width: 40px;
  fill: var(--icon-bulb);
  margin: 0 12px;
  .st0 {
    fill: ${({ theme }) =>
      theme.skin === "rac"
        ? "transparent"
        : theme.current === "dark"
          ? "#14162c"
          : "#E3E6EA"};
  }
  .st1 {
    fill: ${({ theme }) =>
      theme.skin === "rac"
        ? theme.current === "dark"
          ? "#fff"
          : "var(--profileMenu)"
        : "                                                                                                           #1a4294"};
  }
  @media (max-width: 767px) {
    margin: 0;
  }
`;

export const IconBulbHidden = styled.div`
  width: 40px;
  margin: 0 12px;
`;

export const SessionTime = styled.div`
  position: ${isMobileOnly && "absolute"};
  top: ${({ isSv }) => isMobileOnly && (isSv ? "9px" : "5px")};
  width: ${isMobileOnly && "100%"};
  left: ${isMobileOnly && "0"};
  text-align: ${isMobileOnly && "center"};
  padding-top: ${isMobileOnly && "5px"};
  display: ${({ isSv }) => isMobileOnly && isSv && "ruby"};
  div,
  p {
    margin: ${!isMobileOnly && "0 10px"};
    color: #ffff;
    font-size: 0.6rem;
    max-width: ${({ isSv }) => (isSv || isMobileOnly ? "100%" : "100px")};
    line-height: 1.3;
    padding: ${isMobileOnly && "0 1px"};
  }
`;

export const LanguageSelect = styled.select`
  background-color: transparent;
  outline: none;
  border: none;
  color: #fff;
  font-size: inherit;
  -moz-appearance: ${({ theme }) =>
    theme.skin === "yet" ||
    theme.skin === "fun" ||
    theme.skin === "cac" ||
    theme.skin === "hyc"
      ? ""
      : "none"};
  -webkit-appearance: ${({ theme }) =>
    theme.skin === "yet" ||
    theme.skin === "fun" ||
    theme.skin === "cac" ||
    theme.skin === "hyc"
      ? ""
      : "none"};
  background-color: var(--racProfileMenuCol);
  color: ${({ theme }) =>
    theme.skin === "nbc" || theme.skin === "cac" || theme.skin === "hyc"
      ? "#fff"
      : theme.skin === "rac"
        ? "var(--profileMenu)"
        : "var(--headerbtn)"};
  border-radius: ${({ theme }) =>
    theme.skin === "fun" || theme.skin === "cac"
      ? "20px"
      : theme.skin === "hyc"
        ? "10px"
        : theme.skin === "nbc" || theme.skin === "yet"
          ? "0.5rem"
          : "5px"};
  padding: ${({ theme, userInfoProp }) =>
    theme.skin === "nbc" ||
    theme.skin === "yet" ||
    theme.skin === "fun" ||
    theme.skin === "rac" ||
    theme.skin === "hyc"
      ? theme.skin === "fun" && userInfoProp
        ? "14px"
        : userInfoProp
          ? "10px"
          : "7px"
      : "5px"};
  text-transform: uppercase;
  font-weight: ${({ theme }) =>
    theme.skin === "nbc" || theme.skin === "yet" || theme.skin === "fun"
      ? "500"
      : "700"};
  margin-top: ${({ userInfoProp, theme }) =>
    userInfoProp && theme.skin === "nbc" ? "3px" : userInfoProp && "7px"};
  margin: ${({ theme }) => (theme.skin === "rac" ? "2px 5px" : "0 5px")};
  border: ${({ theme }) =>
    theme.skin === "nbc"
      ? "1px solid #977ea2"
      : theme.skin === "cac" || theme.skin === "qbc" || theme.skin === "bec"
        ? "1px solid #979797"
        : ""};
  cursor: pointer;
  text-align: center;
  transition: background-color 300ms;

  :hover {
    background-color: ${({ theme }) =>
      theme.skin === "fun"
        ? "#195ab8"
        : theme.skin === "cac"
          ? "#322d2e"
          : theme.skin === "hyc"
            ? "#211b48"
            : theme.skin === "rac"
              ? "#3300d1"
              : "#21729c"};
  }

  option {
    background-color: ${({ theme }) =>
      theme.skin === "nbc"
        ? "#481a4b"
        : theme.skin === "fun"
          ? "#195ab8"
          : theme.skin === "cac"
            ? "#1E1D19"
            : theme.skin === "hyc"
              ? "#000"
              : theme.skin === "rac"
                ? "var(--headerbtn)"
                : "#11628d"};
    color: ${({ theme }) =>
      theme.skin === "fun" ? "var(--headerbtn)" : "#fff"};
    text-align: left;
  }

  /* &::-ms-expand {
    display: none;
  } */
`;
